import script from "./CreateUserPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUserPage.vue?vue&type=script&setup=true&lang=js"

import "./CreateUserPage.vue?vue&type=style&index=0&id=259974d1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-259974d1"]])

export default __exports__